import {Logo, Firms, Search, Billing, Data, Settings} from './navigation_items'
import {Layout} from '@eitje/web_components'
import './index.less'

export const NavigationHeader = () => {
	return (
		<Layout height={50} horizontal="last-item-end" className="navigation-header" background="white" borderBottom>
			<Logo />
			<Search />
			<Firms />
			<Billing />
			<Data />
			<Settings />
		</Layout>
	)
}
